export default {
  name: 'vans-stg',
  appId: 'wxc7f2c1845f1a51f3',
  wechatId: '208'
};